import { axiosInstance } from './axiosInstance';

export const copyRecordByID = async (data) => {
    try {
        const response = await axiosInstance.post('/api/v1/adminpanel/copy-record', data);
        return response;
    } catch (error) {
        return error;
    }
};